var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionmenuNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.02 18.8005C4.67 18.4505 4.22 18.2205 3.73 18.1205C3.24 18.0305 2.74 18.0805 2.28 18.2705C1.82 18.4605 1.44 18.7905 1.16 19.2005C0.890004 19.6105 0.75 20.1005 0.75 20.6005C0.75 20.9305 0.820002 21.2505 0.940002 21.5505C1.07 21.8505 1.25 22.1205 1.48 22.3505C1.71 22.5805 1.99 22.7605 2.29 22.8805C2.59 23.0005 2.92 23.0705 3.24 23.0605C3.74 23.0605 4.22 22.9105 4.63 22.6405C5.04 22.3605 5.36 21.9705 5.55 21.5105C5.74 21.0505 5.79 20.5505 5.69 20.0605C5.59 19.5705 5.35 19.1305 5 18.7805L5.02 18.8005Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 4.82049C1.73 5.05049 2.01 5.23049 2.31 5.35049C2.61 5.47049 2.94 5.54049 3.26 5.53049C3.76 5.53049 4.24 5.38049 4.65 5.11049C5.06 4.83049 5.38 4.44049 5.57 3.98049C5.76 3.52049 5.81 3.02049 5.71 2.53049C5.61 2.04049 5.37 1.60049 5.02 1.25049C4.67 0.900493 4.22 0.670492 3.73 0.570492C3.24 0.480492 2.74 0.530493 2.28 0.720493C1.82 0.910493 1.44 1.24049 1.16 1.65049C0.890004 2.06049 0.75 2.55049 0.75 3.05049C0.75 3.38049 0.820002 3.70049 0.940002 4.00049C1.07 4.30049 1.25 4.57049 1.48 4.80049L1.5 4.82049Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.02 10.0405C4.67 9.69053 4.22 9.46053 3.73 9.36053C3.24 9.27053 2.74 9.32053 2.28 9.51053C1.82 9.70053 1.44 10.0305 1.16 10.4405C0.890004 10.8505 0.75 11.3405 0.75 11.8405C0.75 12.1705 0.820002 12.4905 0.940002 12.7905C1.07 13.0905 1.25 13.3605 1.48 13.5905C1.71 13.8205 1.99 14.0005 2.29 14.1205C2.59 14.2405 2.92 14.3105 3.24 14.3005C3.74 14.3005 4.22 14.1505 4.63 13.8805C5.04 13.6005 5.36 13.2105 5.55 12.7505C5.74 12.2905 5.79 11.7905 5.69 11.3005C5.59 10.8105 5.35 10.3705 5 10.0205L5.02 10.0405Z",
    fill: "#26B963"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionmenuNew);
export default __webpack_public_path__ + "static/media/optionmenu-new.f07c417a50371921647c8f58e93cc992.svg";
export { ForwardRef as ReactComponent };